import * as apiUtils from '.'

export interface OrionDeviceResult {
  deviceId: string
  status: 'ingested' | 'skipped' | 'failed' | 'deferred'
  received?: number
  inserted?: number
  reason?: string
}

export interface OrionImportSummary {
  projectId: number
  loggersInProject: number
  considered: number
  totalInserted: number
  deferred: number
  perDevice: OrionDeviceResult[]
}

/**
 * Run the Orion (EWS) import for the loggers currently in a project. `since`
 * (YYYY-MM-DD) backfills only the newly ingested channels (soft sensors and
 * Resistance) from that date; the server caps it at 90 days.
 */
export const runImport = (
  projectId: number,
  since?: string,
): Promise<OrionImportSummary> =>
  apiUtils.POST(
    '/admin/orion-import',
    since ? { projectId, since } : { projectId },
  )
